import React from "react";
import styled from "styled-components";
import { randomRange } from "@stores/vars";
import { continueData } from "@stores/bookdata";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import anime from "animejs";

const Wrap = styled.div``;

const NotificationBadge = styled.div`
  width: 145px;
  height: 145px;
  position: absolute;
  top: 20px;
  right: 55px;
  background: url(${({ img }) => img}) no-repeat;
`;

const NotificationBox = styled.div`
  opacity: 0;
  position: absolute;
  top: 60px;
  right: 225px;
  background-color: ${({ color }) => color};
  border-radius: 50px;
  font-size: 30px;
  color: #000;
  padding: 25px 40px 20px;
  color: #fff;
  &:before {
    content: "";
    position: absolute;
    right: -19px;
    top: 20px;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 19px solid transparent;
    border-left: 41px solid ${({ color }) => color};
  }
  animation: bbar 2s infinite;
`;

const char_m = [
  require("@data/assets/_static/actor_badge_m1.png"),
  require("@data/assets/_static/actor_badge_m2.png"),
  require("@data/assets/_static/actor_badge_m3.png"),
  require("@data/assets/_static/actor_badge_m4.png"),
];
const char_w = [
  require("@data/assets/_static/actor_badge_w1.png"),
  require("@data/assets/_static/actor_badge_w2.png"),
  require("@data/assets/_static/actor_badge_w3.png"),
];

const colors = [
  "#de524b",
  "#e7a500",
  "#edd200",
  "#93bb00",
  "#7eabeb",
  "#aa5aef",
];

/*
오늘은 '방문횟수'번째 학습하는 날이야! (방문횟수관련)
우리 '방문횟수'번째 만나는 날이네?
*/
const MainNotiBadge = ({ vCount }) => {
  const cData = useAtomValue(continueData);
  const welcomeImg =
    window.__welcomeRandom[0] === true
      ? char_m[window.__welcomeRandom[1]]
      : char_w[window.__welcomeRandom[1]];

  const randomMessage = () => {
    const messages = [
      `안녕? 오늘도 열심히 공부해 보자!`,
      `오늘은 어떠한 재미있는 이야기를 들려줄까?`,
      `자! 차이홍 스토리북, 오늘도 출발!`,
      `오늘은 어떤 책을 읽어 볼까?`,
      `재미있는 이야기와 활동, 게임을 해 보자`,
      `오늘은 ${vCount} 번째 학습하는 날이야!`,
      `우리 ${vCount} 번째 만나는 날 이구나?`,
    ];

    return messages[randomRange(0, messages.length - 1)];
  };

  const getContinueMessage = () => {
    const continueMessages = [
      `재미있는 [${cData.title}] 이어서 읽어 볼까?`,
      `재미있는 [${cData.title}] 이어서 보고 싶어!`,
      `[${cData.title}]의 활동 문제를 풀어보자!`,
      `[${cData.title}]의 게임을 함께 해 보자!`,
      `[${cData.title}]의 동영상 같이 봐 볼까?`,
      `[${cData.title}]의 낱말 배우기를 함께 해 볼까?`,
    ];

    return continueMessages[randomRange(0, continueMessages.length - 1)];
  };

  useEffect(() => {
    anime({
      targets: "#notiBox",
      opacity: [0, 1],
      easing: "linear",
      duration: 1000,
    });
  }, []);

  return (
    <Wrap>
      <NotificationBadge img={welcomeImg} />
      <NotificationBox color={colors[randomRange(0, 5)]} id="notiBox">
        {cData ? getContinueMessage() : randomMessage()}
      </NotificationBox>
    </Wrap>
  );
};

export default React.memo(MainNotiBadge);
